import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Col, Row, Card, CardBody } from 'reactstrap'
import moment from 'moment'

import tableWithNavbar from 'Shared/custom/tableWithNavbar'
import PageTitle from 'Shared/custom/PageTitle'
import AnalyticsRangePicker from './components/AnalyticsRangePicker'
import ArtistsTotal from './components/ArtistsTotal'
import ArtistsTotalPaymentPeriod from './components/ArtistsTotalPaymentPeriod'
import ArtistsFirstPaymentPeriod from './components/ArtistsFirstPaymentPeriod'
import ArtistsRepeatedPaymentPeriod from './components/ArtistsRepeatedPaymentPeriod'
import ArtistsCampaigns from './components/ArtistsCampaigns'
import stringifyPickerRanges from './helpers/stringifyPickerRanges'

const getDateStringOfDaysAgo = () => moment().subtract(6, 'day')

const ArtistsAnalytics: React.FunctionComponent = () => {
  const { t } = useTranslation()

  const [startDate, setStartDate] = useState(
    getDateStringOfDaysAgo().format('YYYY-MM-DD')
  )
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))

  const pickerRanges = stringifyPickerRanges(endDate, startDate)

  const { Navbar, Table } = tableWithNavbar(
    [
      t('scheduleCampaignPage.total'),
      t('analytics.totalPaymentPeriod'),
      t('analytics.firstPaymentPeriod'),
      t('analytics.repeatedPaymentPeriod'),
      t('campaignsPage.pageTitle'),
    ],
    <ArtistsTotal />,
    <ArtistsTotalPaymentPeriod pickerRanges={pickerRanges} />,
    <ArtistsFirstPaymentPeriod pickerRanges={pickerRanges} />,
    <ArtistsRepeatedPaymentPeriod pickerRanges={pickerRanges} />,
    <ArtistsCampaigns />
  )

  return (
    <Container>
      <Col>
        <Row>
          <Col lg={12} md={12} xl={12}>
            <PageTitle title={t('campaignsPage.artists')} />

            <Card className="tabs-wrapper">
              <CardBody>
                <div className="tabs tabs--bordered-bottom">
                  <div className="tabs__wrap admin-tabs">
                    <Navbar />
                    <AnalyticsRangePicker
                      setRanges={{ setStartDate, setEndDate }}
                    />
                  </div>
                </div>

                <Table />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Col>
    </Container>
  )
}

export default ArtistsAnalytics
